/// <reference path="../_all.ts" />

declare var pglob : IPhotometerGlobalVar;

module tabs {
  'use strict';

  export class TabCtrl {



    // $inject annotation.
    // It provides $injector with information about dependencies to be injected into constructor
    // it is better to have it close to the constructor, because the parameters must match in count and type.
    // See http://docs.angularjs.org/guide/di
    public static $inject = [
      '$scope',
      '$timeout',
      'anchorNavService',
    ];

    constructor(
      private $scope: ITabCtrlScope
      , private $timeout : ng.ITimeoutService
      , private anchorNavService : navigation.IAnchorNavService
      ) {

      this.tabs = this.tabs || {};

    }

    tabs : { [key : string ] : TabItem };
    isToggleMode: boolean;

    setToggleMode(isToggleMode : boolean) {
      this.isToggleMode  = isToggleMode;
    }

    registerPage(element, pageId : string, routeId : number) : TabItem {
      var t : TabItem = this.tabs[pageId + ':' + routeId];
      if (!t) t = this.tabs[pageId + ':' + routeId] = new TabItem(pageId, routeId);
      t.page = new TabItemPart(element);
      return t;
    }

    registerTitle(element, pageId : string, routeId : number, navKey : string) : TabItem {
      var t : TabItem = this.tabs[pageId + ':' + routeId];
      if (!t) t = this.tabs[pageId + ':' + routeId] = new TabItem(pageId, routeId);
      t.title = new TabItemPart(element);

      //(re)index of all tabs.
      angular.forEach(this.tabs, (tab, key) => {
        tab.index = $(tab.title.element).parent().children().index(tab.title.element);
      });

      var elVisibleParent : HTMLElement = $(element[0]).closest(".tab-root").parent()[0];

      t.navItem = this.anchorNavService.addElement(navKey, elVisibleParent, () : boolean => { 
        return t.isActive;
      });      

      return t;
    }

    onChangeFunction : (oldTab : TabItem, newTab : TabItem) => void;

    onChange(f : (oldTab : TabItem, newTab : TabItem) => void) {
      this.onChangeFunction = f;
    }

    getActiveTab() : TabItem {
      var activeTab : TabItem;
      angular.forEach(this.tabs, (tab, key) => {
        if (tab.isActive) activeTab = tab;
      });
      return activeTab;
    }

    toggleActive(t : TabItem, alwaysActivate? : boolean) {
      var oldActive = this.getActiveTab();
      var newActive : TabItem;

      angular.forEach(this.tabs, (tab, key) => {
        if (tab == t) {
          tab.setActive(alwaysActivate || !this.isToggleMode || !t.isActive);  //only toggle when in togglemode
        } else {
          tab.setActive(false);
        }
      });

      newActive = this.getActiveTab();

      if (this.onChangeFunction) this.onChangeFunction(oldActive, newActive);
    }

    toggleActiveIndex(i : number, alwaysActivate? : boolean) {
      var oldActive = this.getActiveTab();
      var newActive : TabItem;

      angular.forEach(this.tabs, (tab, key) => {
        tab.index = $(tab.title.element).parent().children().index(tab.title.element);
        if (tab.index == i) {
          tab.setActive(alwaysActivate || !this.isToggleMode || !tab.isActive);  //only toggle when in togglemode
        } else {
          tab.setActive(false);
        }
      });
      
      newActive = this.getActiveTab();

      if (this.onChangeFunction) this.onChangeFunction(oldActive, newActive);
    }


  }
}